// import { Search } from "@mui/icons-material";
import { Autocomplete, Checkbox, FormControl, FormControlLabel, TextField } from "@mui/material";
import _ from "lodash";
import React, { SyntheticEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AppState } from "../reducers";
import { LoadableProfileData } from "../reducers/userProfiles";

interface Prop {
    onUserSelectChange(selectedUser: string | string[]): void,
    selectedUserId?: string | string[],
    multiple?: boolean,
    emptySelect?: boolean,
}

type selection = {
    name: string,
    value: string,
}
export default function SelectMultipleUserDropDown(props: Prop) {
    const {t} = useTranslation();
    const [isAll, setIsAll] = useState<boolean>(false);
    const userProfiles = useSelector<AppState, LoadableProfileData>(state => state.userProfiles);
    const [userInstances, setUserInstances] = useState<{ name: string, value: string }[]>([]);
    const [selectedInstances, setSelectedInstances] = useState<string[]>([]);

    useEffect(() => {
        let userOptions: {"value": string, "name": string }[] = [];
        if (userProfiles.kind === "loaded" && userProfiles.data.length > 0) {
            userOptions = userProfiles.data.map(profile => {
                return {
                    name: profile.name?? "unknown",
                    value: profile.user_id?? "unknown",
                }
            })
        }
        setUserInstances(_(userOptions).sortBy((user) => user.name).value());
    }, [])

    const onUserSelectsChangeComboBox = (event: selection[] | null) => {
        if (!event) return;
        let users: string[] = [];
        event.forEach(user => {users.push(user.value);})
        setSelectedInstances(users);
        props.onUserSelectChange(users);
    }

    const onUserSelectChangeComboBox = (event: string | null) => {
        if (event === null || event === undefined) return;
        props.onUserSelectChange(event);
    }

    const handleAll = () => {
        let set_all = isAll;
        setIsAll(!set_all);
        let users: string[] = [];
        
        if (!set_all) {
            userInstances.forEach(user => {users.push(user.value);})
        } else {
            users = selectedInstances;
        }
        props.onUserSelectChange(users);
    }

    const multiple = () => {
        return (
            <>
            <FormControl>
                <FormControlLabel
                    id="butt-all"
                    value="all"
                    control={<Checkbox id="butt-all"/>}
                    label="All"
                    labelPlacement="end"
                    onChange={handleAll}
                />
            </FormControl>
            <FormControl fullWidth>
                <Autocomplete
                    disabled={isAll}
                    disableCloseOnSelect
                    autoHighlight
                    multiple
                    limitTags={2}
                    id="multiple-user-select"
                    options={userInstances}
                    groupBy={(option: { name: string }) => option.name.charAt(0)}
                    getOptionLabel={ (option: { name: string; }) => option.name}
                    isOptionEqualToValue={(option, value) => option.name === value.name}
                    renderOption={(props, option) => {return (<li {...props} key={option.value}>{option.name}</li>)}}
                    renderInput={(params) => ( 
                        <TextField 
                            {...params} 
                            error={props.emptySelect}
                            label={t("selectUserDropdown.label_select_user")} 
                            helperText={props.emptySelect? 
                                t("newAnnouncementTable.helper_text_select_user") : null }
                        /> 
                    )}
                    onChange={(e: SyntheticEvent<Element, Event>, value: selection[] | null) => onUserSelectsChangeComboBox(value)}
                />
            </FormControl>
            </>
        )
    }

    const single = () => {
        return (
            <FormControl fullWidth>
                <Autocomplete
                    autoHighlight
                    autoComplete
                    disableClearable
                    freeSolo
                    id="single-use-Select"
                    options={userInstances}
                    groupBy={(option: { name: string }) => option.name.charAt(0)}
                    getOptionLabel={(option: string | {name: string, value: string}) => typeof option === "object"? option.name : option}
                    renderOption={(props, option) => {return (<li {...props} key={option.value}>{option.name}</li>)}}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t("selectUserDropdown.label_select_user")}
                            InputProps={{
                                ...params.InputProps,
                                type: "search",
                            }}
                        />
                    )}
                    onInputChange={(e: SyntheticEvent, value: string) => onUserSelectChangeComboBox(userInstances.find(user => user.name === value)?.value?? "")}
                />
            </FormControl>
        )
    }

    return (
        <>
        {
            props.multiple?
                multiple() :
                single()
        }
        </>
    )
}